import { useEffect, useState } from "react";
import type * as React from "react";

import { formatClockTime } from "./TimeLabel";
import { cn } from "../lib/cn";

export interface DisplayClockProps extends Omit<
  React.TimeHTMLAttributes<HTMLTimeElement>,
  "children" | "dateTime"
> {
  now?: Date;
  ref?: React.Ref<HTMLTimeElement>;
}

export function DisplayClock({ now, className, ...rest }: DisplayClockProps) {
  const [tick, setTick] = useState(() => new Date());

  useEffect(() => {
    if (now) return;
    let interval: ReturnType<typeof setInterval> | undefined;
    const first = setTimeout(
      () => {
        setTick(new Date());
        interval = setInterval(() => setTick(new Date()), 60_000);
      },
      60_000 - (Date.now() % 60_000),
    );
    return () => {
      clearTimeout(first);
      if (interval) clearInterval(interval);
    };
  }, [now]);

  const shown = now ?? tick;

  return (
    <time
      dateTime={shown.toISOString()}
      className={cn(
        "whitespace-nowrap text-mono-time text-sm text-annotation",
        className,
      )}
      {...rest}
    >
      {formatClockTime(shown, true)}
    </time>
  );
}
